<script setup>
import { ref, provide, onMounted } from 'vue';
import TwButton from '@/components/generic/tw-button.vue'
const pages = ref([]);
const activeIndex = ref(0);

defineProps({
  noNavigation: {
    type: Boolean,
    default: false
  }
});


function setActive(index) {
  activeIndex.value = index;
}
function nextPage() {
  if(activeIndex.value === pages.value.length - 1) {
    return;
  }
  activeIndex.value = activeIndex.value + 1;
}

function previousPage() {
  if(activeIndex.value === 0) {
    return;
  }
  activeIndex.value = activeIndex.value - 1;
}


provide('registerPage', (page) => {
  pages.value.push({
    index: pages.value.length,
    ...page
  });
  return pages.value.length - 1
});

defineEmits(['finished']);
provide('activeIndex', activeIndex);
provide('setActive', setActive);

defineExpose({
  setActive,
  nextPage,
  previousPage
});

</script>

<template>
  <div>
    <slot name="default" />
    <div v-if="!noNavigation" class="flex flex-row-reverse gap-2 my-2">
      <tw-button v-if="activeIndex < pages.length-1" variant="primary" @click="setActive(activeIndex+1)">
        Next
      </tw-button>
      <tw-button v-if="activeIndex === pages.length-1" variant="success" @click="$emit('finished')">
        Finish
      </tw-button>
      <tw-button variant="primary" :disabled="activeIndex === 0" @click="setActive(activeIndex-1)">
        Previous
      </tw-button>
    </div>
  </div>
</template>

<style scoped>

</style>
